import { PageContent } from '@va/dashboard/shared/ui-layout';
import { useTranslate } from '@va/localization';
import { Paragraph } from '@va/ui/design-system';
import TrackingInstallAsNativePlatform from './TrackingInstallAsNativePlatform';

export const TrackingCodeNative = () => {
  const translate = useTranslate();
  return (
    <PageContent>
      <Paragraph variant={'display'} variantSize={'small'} className='mb-3'>
        {translate('trackingCode.installation.installAsNativePlatformSubtitle')}
      </Paragraph>
      <TrackingInstallAsNativePlatform />
    </PageContent>
  );
};
